import * as React from "react";

import { FormattedHTMLMessage } from "react-intl";

// resources
import PACKS from "common/icons/packs";
import { IconWrapper } from "app/common/icons";

const styles = require("./emptyMessage.scss");

interface IProps extends React.HTMLProps<HTMLDivElement> {
  messageId: string;
}

const EmptyMessage = ({ messageId, style }: IProps) => {
  return (
    <div className={styles.emptyCardWrapper} style={style}>
      <IconWrapper
        icon={PACKS.GENERAL.NO_DATA_01}
        className={styles.emptyCard}
      />
      <FormattedHTMLMessage id={messageId} />
    </div>
  );
};

export default EmptyMessage;
